import React, { Component } from "react";
import TrackerReport from "./Report.MedicineTracker";
import MedicineFilter from "./Report.MedicineFilter";

class Medicine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "Filter",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "Filter") {
      return <MedicineFilter onClick={this.handleClick} />;
    } else
      return (
        <TrackerReport data={this.state.data} onCloseClick={this.handleClick} />
      );
  }

  handleClick(mode, data) {
    this.setState({ mode, data });
  }
}

export default Medicine;
